/* eslint-disable */
import { _, React, classNames, withStyles, StyledProps } from '@api'
import { PrimaryIconButton, CentricTheme } from 'centric-ui-components'
import { Input, InputAdornment } from '@material-ui/core'
import { Search, Close } from '@material-ui/icons'

const styles = (theme: CentricTheme) => ({
  searchWrapper: {
    width:   '100%',
    display: 'flex',
    flex:    1
  },
  inputWrapper:  {
    width:   '100%',
    padding: `0 ${theme.spacing()}px`
  },
  input:         {
    width: '100%'
  },
  icon:          {
    color: 'rgba(0, 0, 0, 0.54)'
  }
})

interface MyProps extends StyledProps {
  onChange?: (e) => void
  value: string
}

export class SearchFieldComponent extends React.Component<MyProps, { search: boolean }> {
  static defaultProps = {}

  state = {
    search: false
  }

  onClickSearch = () => {
    if (!this.state.search) {
      this.setState({
        search: true
      })
    }
  }

  onClickClose = () => {
    this.setState({
      search: false
    })
  }

  render() {
    const {className, classes, value, onChange} = this.props
    return (
      <div className={classNames(className, classes.searchWrapper)}>
        <PrimaryIconButton
          icon={<Search className={classes.icon}/>}
          onClick={this.onClickSearch}
          disabled={false}
        />
        {this.state.search === true && <div className={classes.inputWrapper}>
          <Input
            classes={{root: classes.input}}
            value={value}
            onChange={onChange}
            autoFocus
            endAdornment={
              <InputAdornment position='end'>
                <PrimaryIconButton
                  icon={<Close className={classes.icon}/>}
                  disabled={false}
                  onClick={this.onClickClose}
                />
              </InputAdornment>
            }
          />
        </div>}
      </div>
    )
  }
}

@(withStyles as any)(styles)
export class SearchField extends SearchFieldComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/SearchField.tsx